<ng-container [caLocalizationScope]="localizationScope">
  <div class="impersonation-wrapper px-3">
    <f-inline-alert [type]="Alert.Warning" [showCancelButton]="false" rootCssClass="impersonation-alert">
      <div data-automation-id="impersonation-banner-content">
        <span class="me-2">{{
          'impersonationModeMessage' | caLocalize : { userName: userName$ | async, accountName: accountName$ | async }
        }}</span>
        <span class="link link-primary" (click)="exitImpersonation()">{{ 'exitImpersonation' | caLocalize }}</span>
      </div>
    </f-inline-alert>
  </div>
</ng-container>
